module.exports = __webpack_public_path__ + "static/media/d2.3c746ae3.jpg";